import type { FeatureConfig, FeatureToggle } from '@dx-ui/gql-types';
import { addDatadogFeatureFlag } from '@dx-ui/framework-datadog-rum';

export type FeatureTogglesQueryData = {
  featureToggles: Pick<FeatureToggle, 'name' | 'enabled'>[];
};

export type FeatureConfigsQueryData = FeatureTogglesQueryData & {
  featureConfigs: Pick<FeatureConfig, 'name' | 'conditions' | 'config'>[];
};

export function getIsFeatureToggleEnabled({
  featureToggleData,
  name,
}: {
  featureToggleData: FeatureTogglesQueryData | null | undefined;
  name: string;
}) {
  const isToggleEnabled =
    featureToggleData?.featureToggles?.find((toggle) => toggle.name === name)?.enabled || false;
  addDatadogFeatureFlag(name, isToggleEnabled);

  return isToggleEnabled;
}

export function getFeatureConfig<T = Record<string, unknown>>({
  featureToggleData,
  name,
}: {
  featureToggleData: FeatureConfigsQueryData | undefined;
  name: string;
}): T | null {
  const toggleEnabled = getIsFeatureToggleEnabled({ featureToggleData, name });
  const allConfigs = featureToggleData?.featureConfigs || [];
  const searchedConfig = allConfigs.find((toggle) => toggle.name === name);
  return toggleEnabled ? searchedConfig?.config : null;
}
